import type { SupabaseClient } from "@supabase/supabase-js";
import type { FeedFiltersState } from "@/components/feed/feed-filters";
import type { CollectorPreferenceKey } from "@/lib/collector-preference-keys";

const PRODUCT_SLUG_LOOKUP: Partial<Record<CollectorPreferenceKey, readonly string[]>> = {
  sneakers: ["sneakers", "sneaker"],
  figures: ["figures", "figure"],
  vintage: ["vintage"],
  watches: ["watches", "watch"],
  comics: ["comics", "comic"],
  art: ["art"],
};

export async function collectorKeysToFeedFiltersPartial(
  supabase: SupabaseClient,
  keys: CollectorPreferenceKey[]
): Promise<Partial<FeedFiltersState>> {
  if (!keys.length) {
    return {
      listingCategory: null,
      categories: [],
      brands: [],
      themes: [],
      conditions: [],
      gradeRange: null,
      sortBy: null,
    };
  }

  const wantsLego = keys.includes("lego");
  const wantsTcg = keys.includes("trading_cards");
  let listingCategory: FeedFiltersState["listingCategory"] = null;
  if (wantsLego && !wantsTcg) listingCategory = "lego";
  else if (wantsTcg && !wantsLego) listingCategory = "trading_card";

  const slugSet = new Set<string>();
  for (const k of keys) {
    const arr = PRODUCT_SLUG_LOOKUP[k];
    if (arr) arr.forEach((s) => slugSet.add(s));
  }
  const slugs = Array.from(slugSet);
  const categories: string[] = [];
  const seen = new Set<string>();
  for (const s of slugs) {
    const { data, error } = await supabase
      .from("taxonomy_items")
      .select("id")
      .eq("type", "product_type")
      .eq("is_active", true)
      .ilike("slug", s)
      .limit(1)
      .maybeSingle();
    if (error || !data?.id || seen.has(data.id)) continue;
    seen.add(data.id);
    categories.push(data.id);
  }

  return {
    listingCategory: listingCategory ?? null,
    categories,
    brands: [],
    themes: [],
    conditions: [],
    gradeRange: null,
    sortBy: null,
  };
}
